export default __webpack_public_path__ + "search.850aefbd1720a157.svg";